import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

interface User {
  uid: string;
  displayName: string;
  email: string;
  kyc: KycData;
  particular?: UserPersonalData;
  empresa?: UserCompanyData;
}

interface KycData {
  result: 0 | 1 | 2; // 0: rejected, 1: approved, 2: pending
  status?: string;
  documents?: string[];
}

interface UserPersonalData {
  nombre: string;
  apellidos: string;
  telefono: string;
  fechaNacimiento: string;
  dni: string;
  pais: string;
  direccion: string;
  ciudad: string;
  codigoPostal: string;
}

interface UserCompanyData {
  nombreEmpresa: string;
  cif: string;
  representante: {
    nombre: string;
    apellidos: string;
    telefono: string;
    email: string;
  };
}

@Component({
  selector: 'app-set-kyc',
  templateUrl: './set-kyc.component.html',
  styleUrls: ['./set-kyc.component.css'],
  standalone: true,
  imports: [CommonModule, NgxJsonViewerModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SetKycComponent implements OnDestroy {
  // ✅ KISS Pattern: Simple subscription cleanup
  private destroy$ = new Subject<void>();
  
  users: User[] = [];

  constructor(private afs: AngularFirestore) { 
    this.afs.collection('users', ref => ref.where('kyc.result', '==', 2)).valueChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: unknown) => {
      if (res !== undefined && res !== null) {
        this.users = res as User[];
      }
    });
  }

  aprove(uid: string): void {
    const kycUpdate: Partial<KycData> = { result: 1 };
    this.afs.collection('users').doc(uid).set({
      kyc: kycUpdate
    }, {merge: true});
  }

  reject(uid: string): void {
    const kycUpdate: Partial<KycData> = { result: 0 };
    this.afs.collection('users').doc(uid).set({
      kyc: kycUpdate
    }, {merge: true});
    this.deleteData(uid);
  }

  deleteData(uid: string): void {
    this.afs.collection('pre-registerdata').doc(uid).delete();
  }

  // ✅ KISS Pattern: Simple cleanup
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  reset(uid: string) {
    this.deleteData(uid);
    this.afs.collection('users').doc(uid).get().subscribe((doc: any) => {
      if (doc.exists) {
        const userData = doc.data();
        if (userData) {
          const email = userData?.email;
          const displayName = userData?.displayName;
          const uid = doc.id;
          this.afs.collection('users').doc(uid).set({
            uid: uid,
            email: email,
            displayName: displayName,
          });
        }
      }
    });
  }

}
